import PropTypes from 'prop-types'
import MaskedFiel from './MaskedField'
import emailMask from 'text-mask-addons/dist/emailMask'

class MailField extends MaskedFiel {
    constructor(props){
        super(props);
        this.state = {...this.state, mask: emailMask};
    }
}

MailField.propTypes= {
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
}

export default MailField


// WEBPACK FOOTER //
// ./src/components/custom/MailField.js